import React from "react";
import {
    BlockQuote,
    GoToAction,
    Cite,
    Deck,
    Heading,
    ListItem,
    List,
    Quote,
    Slide,
    Text
} from "spectacle";

const ExpertAdvisory = () =>
    <div>
        <Heading size={4} textColor="fifth" caps>
            Expert Advisory
        </Heading>
        <Text margin="30px 0 0" textColor="primary" textSize={25}>
            We offer expert advisory, where we team up with you to help you get the most value from Sitecore for your customers.
        </Text>
        <Text margin="30px 0 0" textColor="primary" textSize={25}>
            This is typically focused on Context Marketing, analytics (including custom dashboards and visualizations), Personalization, Headless (JSS), xConnect and Machine Learning.
        </Text>
        <Text margin="30px 0 0" textColor="primary" textSize={25}>
            Our expert advisory can be technical, business focused or both, as part of our advisory we typical help create different POC’s that can be used to guide and for the implementation team as support.
        </Text>
    </div>

export default ExpertAdvisory;


// WEBPACK FOOTER //
// ./src/slides/ExpertAdvisory.js